import { createContext, useContext } from 'react';

import type { DynamicGridContextValue } from '../types';

export const DynamicGridContext = createContext<DynamicGridContextValue | null>(
  null
);

export const useDynamicGridContext = (): DynamicGridContextValue => {
  const ctx = useContext(DynamicGridContext);
  if (!ctx) {
    throw new Error(
      'useDynamicGridContext must be used within DynamicGridProvider'
    );
  }
  return ctx;
};
